import React from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import PropTypes from 'prop-types';

import Card from '@/components/common/Card';
import userIcon from '@/components/common/icons/user.svg';
const InspectorCard = ({ data }) => {
  const intl = useIntl();
  const params = useParams();
  const status = params.status || 'active';

  return (
    <Card url={`/inspectors/${status}/${data.public_id}`}>
      <div className="flex items-center flex-wrap">
        <figure className="w-6 h-6 !mr-2 rounded-full overflow-hidden mb-0">
          <img className="w-6 h-6" src={userIcon} alt={intl.formatMessage({ id: 'USER_ICON' })} />
        </figure>
        <div className="font-bold">{data.name}</div>
        <div className="flex-[0_0_100%] w-full mt-[1em] text-[0.8125em] font-bold text-[#919191]">
          {data.neighborhood || intl.formatMessage({ id: 'NEIGHBORHOOD_NOT_REGISTERED_MESSAGE' })}
        </div>
        <div className="flex-[0_0_100%] w-full mt-[1em] text-[0.8125em] font-medium text-[#919191]">
          {data.cellphone || data.phone || intl.formatMessage({ id: 'PHONE_NOT_REGISTERED_MESSAGE' })}
        </div>
      </div>
    </Card>
  );
};

InspectorCard.propTypes = {
  data: PropTypes.object.isRequired,
};

export default InspectorCard;
